import { StudentVisaDocuments } from '../../../types';

export interface VisaMetadata {
  visaType?: string;
  level?: string;
  isVisaShortened?: boolean;
  shortenedDate?: string;
}

export const getVisaMetadata = (visa: StudentVisaDocuments): VisaMetadata => {
  const childDocuments = [
    ...Object.values(visa.visa ?? {}),
    ...Object.values(visa.biometric ?? {}),
    ...Object.values(visa.cas ?? {}),
  ] as VisaMetadata[];

  const firstDefined = <K extends keyof VisaMetadata>(key: K): VisaMetadata[K] =>
    childDocuments.find(document => document?.[key] !== undefined)?.[key];

  return {
    visaType: visa.visaType ?? firstDefined('visaType'),
    level: visa.level ?? firstDefined('level'),
    isVisaShortened: visa.isVisaShortened ?? firstDefined('isVisaShortened'),
    shortenedDate: visa.shortenedDate ?? firstDefined('shortenedDate'),
  };
};
